import { Component, OnInit, inject } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";

@Component({
  selector: "onsip-signup-app-entry",
  templateUrl: "./signup-app-entry.component.html",
  imports: [RouterOutlet]
})
export class SignUpAppEntryComponent implements OnInit {
  private router = inject(Router);

  ngOnInit(): void {
    const params = new URLSearchParams(document.location.search.substring(1));
    const paramUrl = params.get("signup");
    if (paramUrl === "prototype") {
      this.router.navigate(["prototype"], { skipLocationChange: true });
    } else if (paramUrl === "layout") {
      this.router.navigate(["layout"], { skipLocationChange: true });
    } else {
      this.router.navigate(["signup"], { skipLocationChange: true });
    }
  }
}
